import { FOOTER_SIGNUP_DONE } from '../constants';

import { post } from '../Services/http';

export const signUpForNewsletter = (email) => (dispatch) => {
    return post('/api/lime', { email })
        .then((response) => {
            if (response.status === 202) {
                dispatch(signupDone(true));
                return true;
            }
            return false;
        })
        .catch(() => false);
};



export const signupDone = () => ({
    type: FOOTER_SIGNUP_DONE,
    payload: {
        signupDone: true
    }
})